export default {
  name: 'project-tablet',
  props: ['id', 'image', 'name'],
  data () {
    return {

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/project-tablet/index.js